module.exports = __webpack_public_path__ + "assets/close.2a631160.svg";